exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-header[data-v-4948f534]{background-color:#fbfbfb}.setting-body[data-v-4948f534]{background-color:#fdfdfd}input[data-v-4948f534],textarea[data-v-4948f534]{border-style:solid}.token_password_toggle[data-v-4948f534]{position:absolute;margin-top:-30px;right:20px}", ""]);

// exports
